import ProgramsContainer from './programs_container';

const Programs = ProgramsContainer;
export default Programs;
